// services/TemplateService.js
import axios from "axios";
import Config from "../../utils/Config";
const baseUrl = Config.baseUrl;

class TemplateService {
  getHeaders() {
    const token = localStorage.getItem("txtconnect_ng_user_token");
    //console.log("TemplateService Auth token:", token ? "Present" : "Missing");

    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
  }

  // ------------------------------------------
  // Get all custom SMS templates
  // ------------------------------------------
  async getCustomTemplates() {
    //console.log("TemplateService: Fetching custom templates");
    //console.log("Base URL:", baseUrl);
    //console.log("Headers:", this.getHeaders());

    try {
      const response = await axios.get(
        `${baseUrl}api/user/show/sms-templates`,
        {
          headers: this.getHeaders(),
        }
      );

      //console.log("TemplateService API response:", response.data);

      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      console.error("TemplateService getCustomTemplates error:", error);
      console.error("Error response:", error.response);
      console.error("Error message:", error.message);

      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // ------------------------------------------
  // Create new SMS template
  // ------------------------------------------
  async createTemplate(templateData) {
    //console.log("TemplateService: Creating new template");
    //console.log("Template data:", templateData);

    try {
      const requestPayload = {
        name: templateData.name,
        content: templateData.content,
      };

      console.log(
        "Making POST request to:",
        `${baseUrl}api/user/create/sms-template`
      );
      //console.log("Request payload:", requestPayload);

      const response = await axios.post(
        `${baseUrl}api/user/create/sms-template`,
        requestPayload,
        {
          headers: this.getHeaders(),
        }
      );

      //console.log("Template created successfully:", response.data);

      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      console.error("TemplateService createTemplate error:", error);
      console.error("Error response:", error.response);
      console.error("Error message:", error.message);

      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // ------------------------------------------
  // Update existing SMS template
  // ------------------------------------------
  async updateTemplate(templateId, templateData) {
    //console.log(`TemplateService: Updating template ID: ${templateId}`);
    //console.log("Update data:", templateData);

    try {
      const requestPayload = {
        name: templateData.name,
        content: templateData.content,
      };

      console.log(
        "Making PUT request to:",
        `${baseUrl}api/user/update/sms-template/${templateId}`
      );
      //console.log("Request payload:", requestPayload);

      const response = await axios.put(
        `${baseUrl}api/user/update/sms-template/${templateId}`,
        requestPayload,
        {
          headers: this.getHeaders(),
        }
      );

      //console.log("Template updated successfully:", response.data);

      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      console.error("TemplateService updateTemplate error:", error);
      console.error("Error response:", error.response);
      console.error("Error message:", error.message);

      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // ------------------------------------------
  // Delete SMS template
  // ------------------------------------------
  async deleteTemplate(templateId) {
    //console.log(`TemplateService: Deleting template ID: ${templateId}`);

    try {
      console.log(
        "Making DELETE request to:",
        `${baseUrl}api/user/delete/sms-template/${templateId}`
      );

      const response = await axios.delete(
        `${baseUrl}api/user/delete/sms-template/${templateId}`,
        {
          headers: this.getHeaders(),
        }
      );

      //console.log("Template deleted successfully:", response.data);

      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      console.error("TemplateService deleteTemplate error:", error);
      console.error("Error response:", error.response);
      console.error("Error message:", error.message);

      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // ------------------------------------------
  // Get single template by ID (if needed)
  // ------------------------------------------
  async getTemplateById(templateId) {
    //console.log(`TemplateService: Fetching template ID: ${templateId}`);

    try {
      // Note: If your API doesn't have a single template endpoint,
      // you can fetch all and filter, or add this endpoint if available
      const allTemplates = await this.getCustomTemplates();
      
      if (allTemplates.success && allTemplates.data?.data) {
        const template = allTemplates.data.data.find(t => t.id === parseInt(templateId));
        
        return {
          success: true,
          data: template,
          status: 200,
        };
      }
      
      return allTemplates;
      
    } catch (error) {
      console.error("TemplateService getTemplateById error:", error);

      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

// Create singleton instance
const templateService = new TemplateService();
export default templateService;